import { HttpClient } from '@angular/common/http';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { WebSocketService } from 'src/app/shared/services/web-socket.service';
import { localStorageConstants } from './constants';
import { Apollo } from 'apollo-angular';
import { GET_USER_BY_AZURE_ID } from '../graph-queries';
import { User } from 'src/app/modules/users/models/user';

export type Profile = {
  displayName?: string;
  jobTitle?: string;
  mail?: string;
  officeLocation?: string;
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly AZURE_GRAPHQL_URL: string =
    'https://graph.microsoft.com/v1.0/me';

  profile$: WritableSignal<Profile> = signal({});
  constructor(
    private http: HttpClient,
    private wsService: WebSocketService,
    private apolloClient: Apollo,
  ) {}

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>(this.AZURE_GRAPHQL_URL);
  }

  selfProvisionUser(profile: Profile) {
    this.wsService.send({
      metadata: {
        eventType: 'CREATE',
        domain: 'UserAccount',
      },
      data: {
        firstName: profile.givenName,
        lastName: profile.surname,
        email: profile.userPrincipalName,
        azureOid: profile.id,
        officeLocation: profile.officeLocation,
      },
    });
  }

  setFacilities(profile: Profile) {
    this.apolloClient
      .query({
        query: GET_USER_BY_AZURE_ID,
        variables: {
          id: profile.id,
        },
      })
      .subscribe((response: any) => {
        let loggedInUser: User = response.data.GetUserByAzureId;
        localStorage.setItem(
          localStorageConstants.USER_FACILITIES_KEY,
          JSON.stringify(loggedInUser.FacilityAssignments),
        );
      });
  }
}
